
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, NavigationEnd, NavigationStart, RouterEvent } from "@angular/router";
import { filter, map, mergeMap, tap } from "rxjs/operators";
import { CalculatorService } from './calculator.service';
import { CaseFieldsService } from "../user/add-case/case-fields.service";
import { fadeAnimation } from '../../animations/fade.animation';
import { enterAnimation } from '../../animations/enter.animation';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import * as FileSaver from 'file-saver';

import { PicklistItemService } from "../shared-data-entry/picklist-item.service";
import { PicklistItemResponse } from '../../shared/picklist-item-response';
import { PicklistItemModel } from '../../shared/picklist-item-model';
import { CaseModel } from '../../shared/case/case-model';
import { PreCaseCalculationModel } from '../../shared/pre-case-calculation-model';
import { PreCaseCalculationtResponse } from '../../shared/pre-case-calculation-response';
import { CaseReqResourcesModel } from '../../shared/case/case-req-resources-model';
import { CaseProcEfficacyModel } from '../../shared/case/case-proc-efficacy-model';
import { CaseProcAssignmentModel } from '../../shared/case/case-proc-assignment-model';
import { CaseAEItemModel } from '../../shared/case/case-ae-item-model';
import { CasePreCalcInfoModel } from '../../shared/case/case-pre-calc-info-model';
import { CaseHemoDynamicsInfoModel } from '../../shared/case/case-hemo-dynamics-info-model';
import { CaseSaveResponse } from '../../shared/case-save/case-save-response';
import { LoginService } from "../user/login.service";
import { CaseService } from "../user/add-case/case.service";
import { NgForm } from "@angular/forms";
import { CaseResponse } from '../../shared/case/case-response';
import { forEach } from '@angular/router/src/utils/collection';

@Component({
  selector: 'app-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.scss'],
  animations: [enterAnimation]
})
export class CalculatorComponent  implements OnInit, OnDestroy {
  @ViewChild('calculatorform')
  form: NgForm;
  public picklistItemService: PicklistItemService;
  public user: LoginService;


  showResults:boolean = false;
  btnText: string = "CALCULATE";
  caseNumber: number;
  operator: string = "";
  operators = [];
  cathDate: string = "";
  patAge: string = "";
  patSex: string = "";
  patWeight: string = "";
  patHeight: string = "";
  primaryDiagnosis: string = "";
  geneticSyndrom: string = "";
  cathPrior: string = "";
  surPrior: string = "";
  caseType: string="";
  showSummary: boolean = false;
  showProgressBar: boolean = true;
  calculationStage: boolean = true;
  dropDownCrisp: PicklistItemResponse;
  preCaseCalculationModel: PreCaseCalculationModel;
  caseService: CaseService;
  caseModel: CaseModel;
  public calc: CalculatorService;
  public fields: CaseFieldsService;
  constructor(calc: CalculatorService, _fields: CaseFieldsService, private router: Router, _picklistItemService: PicklistItemService, _user: LoginService, _caseService: CaseService) { 
    
    this.calc = calc;
    this.fields = _fields;
    this.user = _user;
    this.caseService = _caseService;
    this.resetFieldsCheck();

    this.picklistItemService = _picklistItemService;
    this.picklistItemService
      .getPicklistItem("1", "CRISP Physiologic category")
      .subscribe(data => this.populatePicklistItems(data, "CRISP"));
  
    this.picklistItemService
      .getPicklistItem(this.user.user.HospitalId.toString(), "OPERATORS")
      .subscribe(data => this.populateOperatorPicklistItems(data));

  }

  populatePicklistItems(picklistItemResponse: PicklistItemResponse, type) {
    this.picklistItemService.picklistItemModel = picklistItemResponse.DataObject;
    this.picklistItemService.mapToDropDown();    

 
      this.dropDownCrisp = picklistItemResponse;

  }
  populateOperatorPicklistItems(picklistItemResponse: PicklistItemResponse) {
    this.operators = picklistItemResponse.DataObject;
  }
  ngOnInit() {
  }

  //gets the recorded procedures as an array
  getProceduresArray() {
  
    var procedure = [];
    var getproc = [];
    var proc = this.getProcedures();
    if (proc != null) {
      getproc = Object.getOwnPropertyNames(this.getProcedures());


      for (let pr in Object.values(proc)) {
        procedure[pr] = getproc[pr] + "," + Object.values(proc)[pr]["primary"];
      }
    }
    return procedure;

    
  }

  //retrieves the recorded procedure list from the case list service
  getProcedures() {
    return this.fields.getField("Pre-Case Calculation", "Recorded Procedures").value;
  }

  showCalculatewBtn() {
    let currentDate = new Date();
    let cathDate = new Date(this.fields.getField("Case Identification", 'Cath Date').value);
    currentDate.setHours(0, 0, 0, 0);
    cathDate.setHours(0, 0, 0, 0);
    if (cathDate >= currentDate) {
      return true;
    }
    return false;
  }
  PreCaseSummary() {
    this.showSummary = true;
    this.patAge = this.calc.case.CaseClinicalInfo.PatAge + " "
    var agetype= this.calc.case.CaseClinicalInfo.PatAgeType == 0 ? 'Days' :
      this.calc.case.CaseClinicalInfo.PatAgeType == 1 ? 'Months' : this.calc.case.CaseClinicalInfo.PatAgeType == 2 ? 'Years' : '';
    this.patAge = this.calc.case.CaseClinicalInfo.PatAge + " " + agetype;
    this.patSex = this.calc.case.CaseClinicalInfo.PatSex == '1' ? 'Male' : this.calc.case.CaseClinicalInfo.PatSex == '2' ? 'Female' : '';

    if (this.calc.case.CaseClinicalInfo.PatWeight != null)
      this.patWeight = this.calc.case.CaseClinicalInfo.PatWeight + " kg"
    if (this.calc.case.CaseClinicalInfo.PatHeight != null)
      this.patHeight = this.calc.case.CaseClinicalInfo.PatHeight + " cm"

    if (this.fields.getField('Clinical Characteristics', 'PrimarySTS').text != null)
      this.primaryDiagnosis = this.fields.getField('Clinical Characteristics', 'PrimarySTS').text;

    this.geneticSyndrom = this.calc.case.CaseClinicalInfo.GenSyndromeInd == '1' ? 'Yes' : 'No';
    this.cathPrior = this.calc.case.CaseClinicalInfo.PrevCathlast90dInd == '1' ? 'Yes' : 'No';
    this.surPrior = this.calc.case.CaseClinicalInfo.PrevSurglast90dInd == '1' ? 'Yes' : 'No';
    this.caseNumber = this.calc.case.CaseId;
    this.cathDate = this.calc.case.CathDate;
    if (this.operators.length > 0 && this.calc.case.PrimaryOperatorId > 0)
      this.operator = this.operators.find(x => x.ChoiceCode == this.calc.case.PrimaryOperatorId).ChoiceText;
    if (this.fields.getField("Pre-Case Calculation", 'Case Type').value != null)
      this.caseType = this.fields.getField("Pre-Case Calculation", 'Case Type').value;
  }


  onPrint() {

    let pdf = new jspdf('p', 'mm', 'a4');
  
    const filename = 'PreCaseSummary.pdf';


    html2canvas(document.querySelector('#precaseSummaryReport')).then(canvas1 => {

      pdf.addImage(canvas1.toDataURL('image/jpeg'), 'JPEG', 10, 20, 191, 255);
     
        pdf.save(filename);
       
    });
      
  }

  onPrintCancel() {
    this.showSummary = false;
  }

  changeView($event) {
    //window.onbeforeunload = null;
    var keys = Object.keys(this.fields.getField('Pre-Case Calculation', "Recorded Procedures").value);
    var len = keys.length;
    if (len==0) {
      this.fields.setValue('Pre-Case Calculation', "Recorded Procedures", null);
    }
    let currentDate = new Date();
    let cathDate = new Date(this.fields.getField("Case Identification", 'Cath Date').value);
    currentDate.setHours(0, 0, 0, 0);
    cathDate.setHours(0, 0, 0, 0);
    if (this.fields.getField('Clinical Characteristics', 'Age').value && len > 0 && cathDate >= currentDate
      && this.fields.getField("Pre-Case Calculation", 'Single Ventricle Physiology').value != null) {
      this.showResults = !this.showResults;
    }

    if (this.showResults) {
      this.btnText = "BACK";
      this.showProgressBar = true;
      this.calculationStage = true;
      this.preCaseCalculationModel = new PreCaseCalculationModel();
      this.preCaseCalculation();
      
    }
    else {
      this.btnText = "CALCULATE";
      this.calculationStage = false;
    }
  }

  preCaseCalculation() {
    //if (this.caseService.saveCaseId) {
    //  this.fields.calculate = true;
    //    this.router.navigate(['/user-portal/edit-case/save/' + this.caseService.saveCaseId]);
    //}
    //SaveForCalculation();
    this.loadCase();
    this.calc.case = this.caseService.case;
    if (this.calc.case.CaseId) {
      this.calc.save().subscribe(data => this.saveResponse(data));
    }
    else {
      this.btnText = "CALCULATE";
      this.showResults = !this.showResults;
    }
  }
  private saveResponse(data: CaseSaveResponse) {
    let caseSaveStatusModel = data.DataObject;
    if (caseSaveStatusModel.Casestatus === "Saved Succesfully") {
      this.calc.getPreCaseCalculationValue(this.calc.case.CaseId, this.calc.case.CaseUpdatedby).subscribe(data => this.loadResponse(data));
    }
  }

  private loadResponse(data: PreCaseCalculationtResponse) {
    this.preCaseCalculationModel = data.DataObject;
    this.showProgressBar = false;
    let emtyValue = "---";
    //PreCaseCardiacStatus
    let preCaseCardiacStatus = this.fields.getField("Pre-Case Calculation", 'Physiologic Category').value;
    let preCaseCardiacStatusView: string;
    if (preCaseCardiacStatus == 'CPC02') {
      preCaseCardiacStatusView = '1';
    }
    else if (preCaseCardiacStatus == 'CPC03') {
      preCaseCardiacStatusView = '2';
    }
    else if (preCaseCardiacStatus == 'CPC04') {
      preCaseCardiacStatusView = '3';
    }
    else {
      preCaseCardiacStatusView = emtyValue;
    }

    this.preCaseCalculationModel.PreCaseCardiacStatus = preCaseCardiacStatusView;

    if (!this.preCaseCalculationModel.AdverseEventRisk) {
      this.preCaseCalculationModel.AdverseEventRisk = emtyValue;
    }
    if (!this.preCaseCalculationModel.CaseDuration) {
      this.preCaseCalculationModel.CaseDuration = emtyValue;
    }
    if (!this.preCaseCalculationModel.HemodynamicVulnerabilityScore) {
      this.preCaseCalculationModel.HemodynamicVulnerabilityScore = emtyValue;
    }
    else {
      var hemoScore: number = +this.preCaseCalculationModel.HemodynamicVulnerabilityScore;
      if (hemoScore >= 3) {
        this.preCaseCalculationModel.HemodynamicVulnerabilityScore = '≥3'
      }
    }
    if (!this.preCaseCalculationModel.PredictRiskCategory) {
      this.preCaseCalculationModel.PredictRiskCategory = emtyValue;
    }
    if (!this.preCaseCalculationModel.RadiationExposureCategory) {
      this.preCaseCalculationModel.RadiationExposureCategory = emtyValue;
    }
    if (!this.preCaseCalculationModel.RiskCategoryAeRate) {
      this.preCaseCalculationModel.RiskCategoryAeRate = emtyValue;
    }
  }

  ngOnDestroy() {
    this.resetFieldsCheck();
  }

  resetFieldsCheck() {
    if (this.router.url.indexOf("user-portal") == -1) {
      this.fields.resetFields();
    }
  }
  private loadCase() {

    let url = this.router.url;
    let isNotPostSave = (url.indexOf("post-save") === -1);
    if (isNotPostSave) {
      console.log(this.fields.fields);
      //this.caseService.clearCase();

      this.caseService.case.HospitalId = +this.fields.getField("Case Identification", 'Hospital').value;
      this.caseService.case.CaseUpdatedby = this.user.user.UserId.toString();
      this.caseService.case.CaseId = +this.fields.getField("Case Identification", 'Case Number').value;
      this.caseService.case.PrimaryOperatorId = +this.fields.getField("Case Identification", 'Operator').value;
      this.caseService.case.CathDate = this.formatDate(this.fields.getField("Case Identification", 'Cath Date').value);

      if (this.caseService.case.CathDate == '' && isNotPostSave) {
        this.fields.validate = false;
        this.fields.validateDate = true;
        let nav = this.fields.getParent("Case Identification")["link"];
        this.router.navigate([nav]);
      } else {
        this.fields.validateDate = false;
        if (this.formatTime(this.fields.getField("Case Identification", 'Case Time').value) != null) {
          this.caseService.case.CathDate = this.formatDate(this.fields.getField("Case Identification", 'Cath Date').value) + ' ' + this.formatTime(this.fields.getField("Case Identification", 'Case Time').value);
        }
        this.caseService.case.CaseClinicalInfo.CaseClinicalInfoId = this.fields.getField("Clinical Characteristics", 'Id').value;
        this.caseService.case.CaseClinicalInfo.Updatedby = this.caseService.case.CaseUpdatedby;
        this.caseService.case.CaseClinicalInfo.CaseId = this.caseService.case.CaseId;
        this.caseService.case.CaseClinicalInfo.PatAge = this.fields.getField("Clinical Characteristics", 'Age').value;
        this.caseService.case.CaseClinicalInfo.PatAgeType = this.getAgeType(this.fields.getField("Clinical Characteristics", 'Age Unit').value);
        this.caseService.case.CaseClinicalInfo.PatSex = this.fields.getField("Clinical Characteristics", 'Sex').value;
        this.caseService.case.CaseClinicalInfo.PatWeight = this.fields.getField("Clinical Characteristics", 'Weight').value;
        this.caseService.case.CaseClinicalInfo.PatHeight = this.fields.getField("Clinical Characteristics", 'Height').value;
        this.caseService.case.CaseClinicalInfo.PatBSA = this.fields.getField("Clinical Characteristics", 'BSA').value;
        this.caseService.case.CaseClinicalInfo.StsDiagCode = this.setStsDiagCode();
        this.caseService.case.CaseClinicalInfo.PrevCathlast90dInd = this.getTrueFalse(this.fields.getField("Clinical Characteristics", 'Date Last Cath').value);
        this.caseService.case.CaseClinicalInfo.PrevSurglast90dInd = this.getTrueFalse(this.fields.getField("Clinical Characteristics", 'Date Last Cardiac Surgery').value);
        this.caseService.case.CaseClinicalInfo.GenSyndromeInd = this.getTrueFalse(this.fields.getField("Clinical Characteristics", 'Genetic Syndrome').value);
        this.caseService.case.CaseClinicalInfo.NonCardiacProbInd = this.getTrueFalse(!this.fields.getField("Clinical Characteristics", 'Non-cardiac Problems').hide);
        this.caseService.case.CaseClinicalInfo.NonCardiacProbValues = this.fields.getField("Clinical Characteristics", 'Non-cardiac Problems').value;

        this.caseService.case.CaseProcedureInfo.CaseProccharInfoId = this.fields.getField("Procedure Characteristics", 'Id').value;
        this.caseService.case.CaseProcedureInfo.Updatedby = this.caseService.case.CaseUpdatedby;
        this.caseService.case.CaseProcedureInfo.CaseId = this.caseService.case.CaseId;
        this.caseService.case.CaseProcedureInfo.FluroTime = this.fields.getField("Procedure Characteristics", 'Total Fluoro Time').value;
        //this.fields.getField("Procedure Characteristics", "Total Fluoro Time").hide = true;
        this.caseService.case.CaseProcedureInfo.TotalDap = this.fields.getField("Procedure Characteristics", 'Total DAP').value;
        //this.fields.getField("Procedure Characteristics", "Total DAP").hide = true;
        this.caseService.case.CaseProcedureInfo.SheathCathInDateTime = this.formatTime(this.fields.getField("Procedure Characteristics", 'Sheath-in Time').value);
        this.caseService.case.CaseProcedureInfo.SheathCathOutDateTime = this.formatTime(this.fields.getField("Procedure Characteristics", 'Sheath-out Time').value);
        this.caseService.case.CaseProcedureInfo.BloodTransfusion = this.getTrueFalse(this.fields.getField("Procedure Characteristics", 'Blood Transfusions').value);

        if (this.user.IsIqicUser()) {
          this.caseService.case.CaseAddlProcedureInfo.CaseAddlProccharInfoId = this.fields.getField("Procedure Characteristics", 'AddlId').value;
          this.caseService.case.CaseAddlProcedureInfo.Updatedby = this.caseService.case.CaseUpdatedby;
          this.caseService.case.CaseAddlProcedureInfo.CaseId = this.caseService.case.CaseId;
          this.caseService.case.CaseAddlProcedureInfo.FluroPerformedType = this.getTrueFalse(this.fields.getField("Procedure Characteristics", 'Type Fluoro Performed').value);
          this.caseService.case.CaseAddlProcedureInfo.TotalContrastVolumeVal = this.fields.getField("Procedure Characteristics", 'Total Contrast Volume').value;
          this.caseService.case.CaseAddlProcedureInfo.TotalContrastVolumePerKg = this.fields.getField("Procedure Characteristics", 'Total Contrast Volume Per Kg').value;
          this.caseService.case.CaseAddlProcedureInfo.PreCathHemoglobinVal = this.fields.getField("Procedure Characteristics", 'Pre Cath Hemoglobin').value;
        } else {
          this.caseService.case.CaseAddlProcedureInfo = null;
        }

        if (this.fields.getField("Pre-Case Calculation", 'Single Ventricle Physiology').value != null) {
          this.caseService.case.CasePreCalcInfo = new CasePreCalcInfoModel;
          this.caseService.case.CasePreCalcInfo.CasePrecalcinfoId = this.fields.getField("Pre-Case Calculation", 'Id').value;
          this.caseService.case.CasePreCalcInfo.Updatedby = this.caseService.case.CaseUpdatedby;
          this.caseService.case.CasePreCalcInfo.CaseId = this.caseService.case.CaseId;
          this.caseService.case.CasePreCalcInfo.IsSingleVenPhysiology = this.getTrueFalse(this.fields.getField("Pre-Case Calculation", 'Single Ventricle Physiology').value);
          this.caseService.case.CasePreCalcInfo.PhysiologicCategory = this.fields.getField("Pre-Case Calculation", 'Physiologic Category').value;
          this.caseService.case.CasePreCalcInfo.IsSVEDP = this.getTrueFalse(this.fields.getField("Pre-Case Calculation", 'SV EDP').value);
          this.caseService.case.CasePreCalcInfo.IsSysSat = this.getTrueFalse(this.fields.getField("Pre-Case Calculation", 'Sys Sat').value);
          this.caseService.case.CasePreCalcInfo.IsMvSat = this.getTrueFalse(this.fields.getField("Pre-Case Calculation", 'MV Sat').value);
          this.caseService.case.CasePreCalcInfo.IsPAMean = this.getTrueFalse(this.fields.getField("Pre-Case Calculation", 'PA').value);
          this.caseService.case.CasePreCalcInfo.IsQPQS = this.getTrueFalse(this.fields.getField("Pre-Case Calculation", 'Qp:Qs').value);
          this.caseService.case.CasePreCalcInfo.IsPVR = this.getTrueFalse(this.fields.getField("Pre-Case Calculation", 'PVR').value);
        } else {
          this.caseService.case.CasePreCalcInfo = null;
        }

        if (this.fields.getField("Hemodynamics", 'Single Ventricle Physiology').value != null) {
          this.caseService.case.CaseHemoDynamicInfo = new CaseHemoDynamicsInfoModel;
          this.caseService.case.CaseHemoDynamicInfo.CaseHemoDynamicsInfoId = this.fields.getField("Hemodynamics", 'Id').value;
          this.caseService.case.CaseHemoDynamicInfo.Updatedby = this.caseService.case.CaseUpdatedby;
          this.caseService.case.CaseHemoDynamicInfo.CaseId = this.caseService.case.CaseId;
          this.caseService.case.CaseHemoDynamicInfo.IsSingleVenPhysiology = this.getTrueFalse(this.fields.getField("Hemodynamics", 'Single Ventricle Physiology').value);
          this.caseService.case.CaseHemoDynamicInfo.PhysiologicCategory = this.fields.getField("Hemodynamics", 'Physiologic Category').value;
          this.caseService.case.CaseHemoDynamicInfo.IsSVEDP = this.getTrueFalse(this.fields.getField("Hemodynamics", 'SV EDP').value);
          this.caseService.case.CaseHemoDynamicInfo.IsSysSat = this.getTrueFalse(this.fields.getField("Hemodynamics", 'Sys Sat').value);
          this.caseService.case.CaseHemoDynamicInfo.IsMvSat = this.getTrueFalse(this.fields.getField("Hemodynamics", 'MV Sat').value);
          this.caseService.case.CaseHemoDynamicInfo.IsPAMean = this.getTrueFalse(this.fields.getField("Hemodynamics", 'PA').value);
          this.caseService.case.CaseHemoDynamicInfo.IsQPQS = this.getTrueFalse(this.fields.getField("Hemodynamics", 'Qp:Qs').value);
          this.caseService.case.CaseHemoDynamicInfo.IsPVR = this.getTrueFalse(this.fields.getField("Hemodynamics", 'PVR').value);
        } else {
          this.caseService.case.CaseHemoDynamicInfo = null;
        }

        if (this.user.IsIqicUser()) {
          this.caseService.case.CaseAddlHemoDynamicInfo.CaseAddlHemoDynamicId = this.fields.getField("Hemodynamics", 'AddlId').value;
          this.caseService.case.CaseAddlHemoDynamicInfo.CaseId = this.caseService.case.CaseId;
          this.caseService.case.CaseAddlHemoDynamicInfo.Updatedby = this.caseService.case.CaseUpdatedby;
          this.caseService.case.CaseAddlHemoDynamicInfo.IsShuntClosure = this.getTrueFalse(this.fields.getField("Hemodynamics", 'Considered for Shunt Closure').value);
          this.caseService.case.CaseAddlHemoDynamicInfo.IsRecommendedforSC = this.getTrueFalse(this.fields.getField("Hemodynamics", 'Is Recommended for SC').value);
          this.caseService.case.CaseAddlHemoDynamicInfo.IsAVTestingPerfomed = this.getTrueFalse(this.fields.getField("Hemodynamics", 'Acute Vasodilator Testing').value);
          this.caseService.case.CaseAddlHemoDynamicInfo.CongentialHDDiagVal = this.fields.getField("Hemodynamics", 'Congenital Heart Disease Diagnosis').value;
          this.caseService.case.CaseAddlHemoDynamicInfo.VasodilatorAgentName = this.fields.getField("Hemodynamics", 'Name of Vasodilator Agent').value;
          this.caseService.case.CaseAddlHemoDynamicInfo.BasePVRIWuVal = this.fields.getField("Hemodynamics", 'Baseline Pulmonary Vascular Resistance').value;
          this.caseService.case.CaseAddlHemoDynamicInfo.BaseSVRWuVal = this.fields.getField("Hemodynamics", 'Baseline Systemic Vascular Resistance').value;
          this.caseService.case.CaseAddlHemoDynamicInfo.BasePVRSVRWuRatioVal = this.fields.getField("Hemodynamics", 'Baseline PVR:SVR Ratio').value;
          this.caseService.case.CaseAddlHemoDynamicInfo.BaseQPQARatioVal = this.fields.getField("Hemodynamics", 'Baseline Qp:Qs Ratio').value;
          this.caseService.case.CaseAddlHemoDynamicInfo.BaseCardIndCIVal = this.fields.getField("Hemodynamics", 'Baseline Cardiac Index').value;
          this.caseService.case.CaseAddlHemoDynamicInfo.PostPVRIWuVal = this.fields.getField("Hemodynamics", 'Post-Testing Pulmonary Vascular Resistance').value;
          this.caseService.case.CaseAddlHemoDynamicInfo.PostSVRWuVal = this.fields.getField("Hemodynamics", 'Post-Testing Systemic Vascular Resistance').value;
          this.caseService.case.CaseAddlHemoDynamicInfo.PostPVRSVRWuRatioVal = this.fields.getField("Hemodynamics", 'Post-Testing PVR:SVR Ratio').value;
          this.caseService.case.CaseAddlHemoDynamicInfo.PostQPQARatioVal = this.fields.getField("Hemodynamics", 'Post-Testing Qp:Qs Ratio').value;
          this.caseService.case.CaseAddlHemoDynamicInfo.PostCardIndCIVal = this.fields.getField("Hemodynamics", 'Post-Testing Cardiac Index').value;
        } else {
          this.caseService.case.CaseAddlHemoDynamicInfo = null;
        }

        this.caseService.case.CaseProcAssingedlist = this.setCaseTypes(this.caseService.case.CaseUpdatedby, this.caseService.case.CaseId);

        this.caseService.case.CaseProcAEInfo.Updatedby = this.caseService.case.CaseUpdatedby;
        this.caseService.case.CaseProcAEInfo.CaseId = this.caseService.case.CaseId;
        this.caseService.case.CaseProcAEInfo.caseAEItems = this.setAdverseEvents(this.caseService.case.CaseUpdatedby, this.caseService.case.CaseId);
        this.caseService.case.CaseProcAEInfo.PatientDie = this.fields.getField("Adverse Events", "Patient Die").value;
        this.caseService.case.CaseProcAEInfo.UnanticipatedCath = this.fields.getField("Adverse Events", "Unanticipated Catheterization").value;
        this.caseService.case.CaseProcAEInfo.UnanticipatedSurg = this.fields.getField("Adverse Events", "Unanticipated Surgery").value;
        if (this.caseService.case.CaseProcAEInfo.caseAEItems.length > 0) {
          this.caseService.case.CaseProcAEInfo.CaseAENotes = this.fields.getField("Adverse Events", "Description").value;
        } else {
          this.caseService.case.CaseProcAEInfo.CaseAENotes = null;
        }

        this.caseService.case.CaseReqResources = this.setIndicators(this.caseService.case.CaseUpdatedby, this.caseService.case.CaseId);
        this.caseService.case.CaseProcEfficacy = this.setEfficacy(this.caseService.case.CaseUpdatedby, this.caseService.case.CaseId);

        this.caseService.case.CaseEOCAdmDisposn.CaseAdmtDspoId = this.fields.getField("EOC Admit/Disposition", 'Id').value;
        this.caseService.case.CaseEOCAdmDisposn.Updatedby = this.caseService.case.CaseUpdatedby;
        this.caseService.case.CaseEOCAdmDisposn.CaseId = this.caseService.case.CaseId;
        this.caseService.case.CaseEOCAdmDisposn.IsAdmSrcElective = this.getTrueFalse(this.fields.getField("EOC Admit/Disposition", 'Admission Source').value);
        this.caseService.case.CaseEOCAdmDisposn.PostCathLocation = this.fields.getField("EOC Admit/Disposition", 'Post-Cath Location').value;
        this.caseService.case.CaseEOCAdmDisposn.IsUnplannedAdmission = this.getTrueFalse(this.fields.getField("EOC Admit/Disposition", 'Unplanned Admission').value);
        this.caseService.case.CaseEOCAdmDisposn.AdmittedPriorCathInd = this.getTrueFalse(this.fields.getField("EOC Admit/Disposition", 'Admit Prior Cath').value);
        this.caseService.case.CaseEOCAdmDisposn.DischargePostCathInd = this.getTrueFalse(this.fields.getField("EOC Admit/Disposition", 'Discharge Post Cath').value);
        this.caseService.case.CaseEOCAdmDisposn.IsAliveAtDischarge = this.getTrueFalse(this.fields.getField("EOC Admit/Disposition", 'Alive at Discharge').value);

        console.log(this.caseService.case);



      }
    }
  }
  private formatDate(date: string): string {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (isNaN(year)) {
      return '';
    }

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    let response = [month, day, year].join('-');

    if (year < 2000) {
      response = '';
    }

    return response;
  }
  private formatTime(date: string): string {
    if (date == null) {
      return null;
    }

    let d = new Date(date),
      hoursNumber = d.getHours(),
      hours = '' + d.getHours(),
      minutes = '' + d.getMinutes();

    if (isNaN(hoursNumber)) {
      return null;
    }

    if (hours.length < 2) hours = '0' + hours;
    if (minutes.length < 2) minutes = '0' + minutes;

    return hours + ":" + minutes;
  }
  private getAgeType(type: string): number {
    if (type === 'Days') {
      return 0;
    }
    if (type === 'Months') {
      return 1;
    }
    if (type === 'Years') {
      return 2;
    }
  }
  private getTrueFalse(type: boolean): string {
    if (type == null) {
      return null;
    }

    if (type) {
      return "1";
    }
    return "0";
  }
  private setStsDiagCode(): string {
    let sts = this.fields.getField("Clinical Characteristics", 'PrimarySTS').value;
    if (sts) {
      return sts.data.code;
    }

    return "";
  }
  private setCaseTypes(updatedBy: string, caseId: number): CaseProcAssignmentModel[] {
    let result = new Array<CaseProcAssignmentModel>();

    let caseTypes = this.fields.getField("Case Types", "Recorded Procedures").value;
    if (caseTypes != null) {
      let caseTypeNames = Object.getOwnPropertyNames(caseTypes);
      for (let name of caseTypeNames) {
        let item = new CaseProcAssignmentModel;
        item.CaseId = caseId;
        item.Updatedby = updatedBy;
        item.CaseProcAsgnId = 0;

        let caseType = caseTypes[name];
        item.ProcedureCode = caseType["id"].replace("procedure-", "");
        item.IsPrimary = caseType["primary"] === true ? "1" : "0";
        item.IsSecondary = caseType["primary"] === false ? "1" : "0";
        item.IsAnticipatedPrimary = "0";
        item.IsAnticipatedSecondary = "0";
        item.ProcedureTextValue = caseType["details"];
        result.push(item);
      }
    }

    let antCaseTypes = this.fields.getField("Pre-Case Calculation", "Recorded Procedures").value;
    this.fields.getField("Case Types", "Anticipated Procedures").value = antCaseTypes;
    if (antCaseTypes != null) {
      let antCaseTypeNames = Object.getOwnPropertyNames(antCaseTypes);
      if (antCaseTypeNames.length == 0) {
        this.fields.getField("Case Types", "Anticipated Procedures").value = null;
      }
      for (let name of antCaseTypeNames) {
        let item = new CaseProcAssignmentModel;
        item.CaseId = caseId;
        item.Updatedby = updatedBy;
        item.CaseProcAsgnId = 0;

        let caseType = antCaseTypes[name];
        item.ProcedureCode = caseType["id"].replace("procedure-", "");
        item.IsPrimary = "0";
        item.IsSecondary = "0";
        item.IsAnticipatedPrimary = caseType["primary"] === true ? "1" : "0";
        item.IsAnticipatedSecondary = caseType["primary"] === false ? "1" : "0";
        item.ProcedureTextValue = caseType["details"];
        //this.caseType = caseType["name"].substring(caseType["name"].lastIndexOf("|") + 1);
        result.push(item);
      }
    }

    return result;
  }
  private setAdverseEvents(updatedBy: string, caseId: number): CaseAEItemModel[] {
    let result = new Array<CaseAEItemModel>();

    let adverseEvents = this.fields.getField("Adverse Events", "Recorded Events").value;
    if (adverseEvents != null) {
      let adverseEventNames = Object.getOwnPropertyNames(adverseEvents);
      for (let name of adverseEventNames) {
        let item = new CaseAEItemModel;
        item.CaseId = caseId;
        item.Updatedby = updatedBy;
        item.CaseAEId = 0;

        let ae = adverseEvents[name];
        item.AECODE = ae["code"];
        item.AEMajorInd = ae["major"];
        item.AESeriousness = ae["seriousness"];
        item.Timeneeded = ae["timeneeded"];
        item.AeTier = ae["aetier"];
        result.push(item);

        // Seriousness and Timeneeded validation check
        if (ae["seriousness"] != "AES01" && ae["seriousness"] != "AES02" && ae["seriousness"] != "AES03"
          && ae["seriousness"] != "AES04" && ae["seriousness"] != "AES05") {

          this.fields.getField("Adverse Events", "Seriousness").value = null;
        }
        if (ae["timeneeded"] === "" || ae["timeneeded"] === null) {

          this.fields.getField("Adverse Events", "Time Needed").value = null;
        }
      }
    }

    return result;
  }
  private setIndicators(updatedBy: string, caseId: number): CaseReqResourcesModel[] {
    let result = new Array<CaseReqResourcesModel>();

    let categories: Array<string> = ["Airway Management", "Ventilation", "Sedation", "Lines", "Drains", "Mechanical Support", "IV Medications", "Checked6Hours", "Checked24Hours", "Checked48Hours"];
    let procs: Array<string> = ["Pre-Procedure", "Procedural", "Post-Procedure", "48 Hrs Post-Cath"];
    for (let category of categories) {
      for (let proc of procs) {
        try {
          let val = this.fields.getField("Indicators of Required Resources", (category + " " + proc)).value;

          let crrm = new CaseReqResourcesModel;
          crrm.ReqResourceId = this.fields.getField("Indicators of Required Resources", (category + " " + proc)).id;
          crrm.CaseId = caseId;
          crrm.Updatedby = updatedBy;
          crrm.ResourceName = category;
          crrm.ResourceValue = val;
          if ((category + " " + proc) == "Checked6Hours Pre-Procedure") {
            crrm.ResourceValue = this.fields.checked6Hours.toString();
          }

          if ((category + " " + proc) == "Checked24Hours Post-Procedure") {
            crrm.ResourceValue = this.fields.checked24Hours.toString();
          }

          if ((category + " " + proc) == "Checked48Hours 48 Hrs Post-Cath") {
            crrm.ResourceValue = this.fields.checked48Hours.toString();
          }

          if (proc === "Pre-Procedure") {
            crrm.IsResUsedPreProcTime = "1";
            crrm.IsResUsedProcTime = "0";
            crrm.IsResUsedPostProcTime = "0";
            crrm.IsResUsed48HoursTime = "0";
          } else if (proc === "Procedural") {
            crrm.IsResUsedPreProcTime = "0";
            crrm.IsResUsedProcTime = "1";
            crrm.IsResUsedPostProcTime = "0";
            crrm.IsResUsed48HoursTime = "0";
          } else if (proc === "Post-Procedure") {
            crrm.IsResUsedPreProcTime = "0";
            crrm.IsResUsedProcTime = "0";
            crrm.IsResUsedPostProcTime = "1";
            crrm.IsResUsed48HoursTime = "0";
          } else if (proc === "48 Hrs Post-Cath") {
            crrm.IsResUsedPreProcTime = "0";
            crrm.IsResUsedProcTime = "0";
            crrm.IsResUsedPostProcTime = "0";
            crrm.IsResUsed48HoursTime = "1";
          } else {
            crrm.IsResUsedPreProcTime = "0";
            crrm.IsResUsedProcTime = "0";
            crrm.IsResUsedPostProcTime = "0";
            crrm.IsResUsed48HoursTime = "0";
          }

          if (crrm.ResourceValue) {
            result.push(crrm);
          }
        } catch (ex) {
          console.log(ex);
        }
      }
    }

    let category: string = "Nursing Assignment";
    let procsNA: Array<string> = ["6 Hrs Pre-Procedure", "18 to 24 Hrs Post-Cath", "48 Hrs Post-Cath"];
    for (let proc of procsNA) {
      try {
        let crrm = new CaseReqResourcesModel;
        crrm.ReqResourceId = this.fields.getField("Indicators of Required Resources", (category + " " + proc)).id;
        crrm.CaseId = caseId;
        crrm.Updatedby = updatedBy;
        crrm.ResourceName = category;
        crrm.ResourceValue = this.fields.getField("Indicators of Required Resources", (category + " " + proc)).value;

        if (proc === "6 Hrs Pre-Procedure") {
          crrm.IsResUsedPreProcTime = "1";
          crrm.IsResUsedProcTime = "0";
          crrm.IsResUsedPostProcTime = "0";
          crrm.IsResUsed48HoursTime = "0";
        } else if (proc === "18 to 24 Hrs Post-Cath") {
          crrm.IsResUsedPreProcTime = "0";
          crrm.IsResUsedProcTime = "0";
          crrm.IsResUsedPostProcTime = "1";
          crrm.IsResUsed48HoursTime = "0";
          crrm.ResourceName = ">6 hrs post-cath";
        } else if (proc === "48 Hrs Post-Cath") {
          crrm.IsResUsedPreProcTime = "0";
          crrm.IsResUsedProcTime = "0";
          crrm.IsResUsedPostProcTime = "0";
          crrm.IsResUsed48HoursTime = "1";
          crrm.ResourceName = "48 Hrs Post-Cath";
        } else {
          crrm.IsResUsedPreProcTime = "0";
          crrm.IsResUsedProcTime = "0";
          crrm.IsResUsedPostProcTime = "0";
          crrm.IsResUsed48HoursTime = "0";
        }

        if (crrm.ResourceValue) {
          result.push(crrm);
        }
      } catch (ex) {
        console.log(ex);
      }
    }

    // set default value 6 Hours Pre-Procedure when checked6Hours is cehcked only
    if (this.fields.checked6Hours) {
      this.fields.getField("Indicators of Required Resources", "Nursing Assignment 6 Hrs Pre-Procedure").hide = true;
      result = result.filter(function (item) {
        if (item.IsResUsedPreProcTime == "1") {
          if (item.ResourceName == "Airway Management") {
            item.ResourceValue = "AM01";
            return item;
          }
          else if (item.ResourceName == "Ventilation") {
            item.ResourceValue = "VENT01";
            return item;
          }
          else if (item.ResourceName == "Checked6Hours") {
            return item;
          }
          else {
            return;
          }
        }
        else {
          return item;
        }
      });
    }

    // set default value for 24 hours and 48 hours post cath when checked24Hours is cehcked
    if (this.fields.checked24Hours) {
      this.fields.getField("Indicators of Required Resources", "Nursing Assignment 18 to 24 Hrs Post-Cath").hide = true;
      this.fields.getField("Indicators of Required Resources", "Nursing Assignment 48 Hrs Post-Cath").hide = true;
      result = result.filter(function (item) {
        if (item.IsResUsedPostProcTime == "1" || item.IsResUsed48HoursTime == "1") {
          if (item.ResourceName == "Airway Management") {
            item.ResourceValue = "AM01";
            return item;
          }
          else if (item.ResourceName == "Ventilation") {
            item.ResourceValue = "VENT01";
            return item;
          }
          else if (item.ResourceName == "Checked24Hours" || item.ResourceName == "Checked48Hours") {
            return item;
          }
          else {
            return;
          }
        }
        else {
          return item;
        }
      });
    }
    // set default value 48 hours post cath when checked48Hours is cehcked only
    if (this.fields.checked48Hours && !this.fields.checked24Hours) {
      this.fields.getField("Indicators of Required Resources", "Nursing Assignment 48 Hrs Post-Cath").hide = true;
      result = result.filter(function (item) {
        if (item.IsResUsed48HoursTime == "1") {
          if (item.ResourceName == "Airway Management") {
            item.ResourceValue = "AM01";
            return item;
          }
          else if (item.ResourceName == "Ventilation") {
            item.ResourceValue = "VENT01";
            return item;
          }
          else if (item.ResourceName == "Checked48Hours") {
            return item;
          }
          else {
            return;
          }
        }
        else {
          return item;
        }
      });
    }

    return result;
  }
  private setEfficacy(updatedBy: string, caseId: number): CaseProcEfficacyModel[] {
    try {
      let result = new Array<CaseProcEfficacyModel>();
      let record = new CaseProcEfficacyModel;

      let categories: Array<string> = ["AV Procedure indications", "Aortic regurgitation Pre-Procedure", "Aortic regurgitation Post-Procedure", "Peak systolic AV gradient Pre-Procedure", "Peak systolic AV gradient Post-Procedure", "PV Procedure indications",
        "Pulmonary regurgitation Pre-Procedure", "Pulmonary regurgitation Post-Procedure", "Tricuspid valve regurgitation Pre-Procedure", "Tricuspid valve regurgitation Post-Procedure", "ASDDC Procedure Indications", "CP Procedure Indications", "Peak systolic gradient at coarctation Pre-Procedure",
        "Peak systolic gradient at coarctation Post-Procedure", "PDADC Procedure Indications", "PDA shunt Size", "Aortic Valvuloplasty", "Pulmonary Valvuloplasty", "ASD Device Closure", "Residual shunt on echocardiogram", "Coarctation Procedure",
        "Any aneurysm post procedure", "stent migration", "Jailing of head/neck vessels", "New or Changed mitral valve insufficiency", "Any main pulmonary artery or right ventricular outflow tract tear", "Pulmonary Valve Type",
        "Subvalvar Obstruction", "PDA Device Closure", "Residual Shunt", "New left pulmonaryartery stenosis", "New aortic arch obstruction", "Intervention performed",
        "PDA Reason for device removal", "Device removed from body", "Was a second device placed?", "Was the second device removed?", "PDA Reason for second device removal", "Hemolysis", "Pre Pulmonary valve gradient", "Post Pulmonary valve gradient", "ASD shunt Size", "Pre Left Ventricle Dysfunction", "Post Left Ventricle Dysfunction"];

      for (let category of categories) {

        let cpem = new CaseProcEfficacyModel;
        if (category == "Aortic Valvuloplasty" || category == "AV Procedure indications" || category.indexOf("Aortic regurgitation") >= 0
          || category.indexOf("Peak systolic AV gradient") >= 0 || category == "Pre Left Ventricle Dysfunction" || category == "Post Left Ventricle Dysfunction") {
          if (this.fields.getField("Procedural Efficacy", "Aortic Valvuloplasty").value == 1) {
            record = this.setEfficacyArray(category, "EFPRC01", updatedBy, caseId)
            if (record.EfficacyDataValue != null && record.EfficacyDataValue != undefined)
              result.push(record);
          }
          if (category == "Aortic Valvuloplasty" && this.fields.getField("Procedural Efficacy", "Aortic Valvuloplasty").value == 0) {
            record = this.setEfficacyArray(category, "EFPRC01", updatedBy, caseId)
            if (record.EfficacyDataValue != null && record.EfficacyDataValue != undefined)
              result.push(record);
          }

          if (category == "Aortic Valvuloplasty" && this.fields.getField("Procedural Efficacy", "Aortic Valvuloplasty").value == 1) {

            this.fields.getField("Procedural Efficacy", "Aortic regurgitation Pre-Procedure").hide = false;
            this.fields.getField("Procedural Efficacy", "Aortic regurgitation Post-Procedure").hide = false;
            this.fields.getField("Procedural Efficacy", "Peak systolic AV gradient Pre-Procedure").hide = false;
            this.fields.getField("Procedural Efficacy", "Peak systolic AV gradient Post-Procedure").hide = false;
            this.fields.getField("Procedural Efficacy", "AV Procedure indications").hide = false;
          }
          else if (this.fields.getField("Procedural Efficacy", "Aortic Valvuloplasty").value == 0) {
            this.fields.getField("Procedural Efficacy", "Aortic regurgitation Pre-Procedure").hide = true;
            this.fields.getField("Procedural Efficacy", "Aortic regurgitation Post-Procedure").hide = true;
            this.fields.getField("Procedural Efficacy", "Peak systolic AV gradient Pre-Procedure").hide = true;
            this.fields.getField("Procedural Efficacy", "Peak systolic AV gradient Post-Procedure").hide = true;
            this.fields.getField("Procedural Efficacy", "AV Procedure indications").hide = true;
          }
          // cpem.EfficacyProcedureCode = "EFPRC01";
        }
        if (category == "Pulmonary Valvuloplasty" || category == "PV Procedure indications" || category.indexOf("Pulmonary regurgitation") >= 0
          || category == "Pre Pulmonary valve gradient" || category == "Post Pulmonary valve gradient"
          || category.indexOf("Tricuspid valve regurgitation") >= 0 || category == "Pulmonary Valve Type" || category == "Subvalvar Obstruction"
          || category == "Any main pulmonary artery or right ventricular outflow tract tear" || category == "Intervention performed") {
          if (this.fields.getField("Procedural Efficacy", "Pulmonary Valvuloplasty").value == 1) {
            record = this.setEfficacyArray(category, "EFPRC02", updatedBy, caseId)
            if (record.EfficacyDataValue != null && record.EfficacyDataValue != undefined)
              result.push(record);
          }
          if (category == "Pulmonary Valvuloplasty" && this.fields.getField("Procedural Efficacy", "Pulmonary Valvuloplasty").value == 0) {
            record = this.setEfficacyArray(category, "EFPRC02", updatedBy, caseId)
            if (record.EfficacyDataValue != null && record.EfficacyDataValue != undefined)
              result.push(record);
          }

          if (category == "Pulmonary Valvuloplasty" && this.fields.getField("Procedural Efficacy", "Pulmonary Valvuloplasty").value == 1) {
            this.fields.getField("Procedural Efficacy", "PV Procedure indications").hide = false;
            this.fields.getField("Procedural Efficacy", "Pulmonary regurgitation Pre-Procedure").hide = false;
            this.fields.getField("Procedural Efficacy", "Pulmonary regurgitation Post-Procedure").hide = false;
            this.fields.getField("Procedural Efficacy", "Tricuspid valve regurgitation Pre-Procedure").hide = false;
            this.fields.getField("Procedural Efficacy", "Tricuspid valve regurgitation Post-Procedure").hide = false;
          }
          else if (this.fields.getField("Procedural Efficacy", "Pulmonary Valvuloplasty").value == 0) {
            this.fields.getField("Procedural Efficacy", "PV Procedure indications").hide = true;
            this.fields.getField("Procedural Efficacy", "Pulmonary regurgitation Pre-Procedure").hide = true;
            this.fields.getField("Procedural Efficacy", "Pulmonary regurgitation Post-Procedure").hide = true;
            this.fields.getField("Procedural Efficacy", "Tricuspid valve regurgitation Pre-Procedure").hide = true;
            this.fields.getField("Procedural Efficacy", "Tricuspid valve regurgitation Post-Procedure").hide = true;
          }
          // cpem.EfficacyProcedureCode = "EFPRC02";
        }
        if (category == "ASDDC Procedure Indications" || category == "ASD Device Closure" || category == "Residual shunt on echocardiogram" || category == "ASD shunt Size" || category == "New or Changed mitral valve insufficiency") {
          if (this.fields.getField("Procedural Efficacy", "ASD Device Closure").value == 1) {
            record = this.setEfficacyArray(category, "EFPRC03", updatedBy, caseId)
            if (record.EfficacyDataValue != null && record.EfficacyDataValue != undefined)
              result.push(record);
          }

          if (category == "ASD Device Closure" && this.fields.getField("Procedural Efficacy", "ASD Device Closure").value == 0) {
            record = this.setEfficacyArray(category, "EFPRC03", updatedBy, caseId)
            if (record.EfficacyDataValue != null && record.EfficacyDataValue != undefined)
              result.push(record);
          }

          if (category == "ASD Device Closure" && this.fields.getField("Procedural Efficacy", "ASD Device Closure").value == 1) {
            this.fields.getField("Procedural Efficacy", "ASDDC Procedure Indications").hide = false;
            if (this.fields.getField("Procedural Efficacy", "Residual shunt on echocardiogram").value == 1) {
              this.fields.getField("Procedural Efficacy", "ASD shunt Size").hide = false;
            }
            else {
              this.fields.getField("Procedural Efficacy", "ASD shunt Size").hide = true;
            }

          }
          else if (this.fields.getField("Procedural Efficacy", "ASD Device Closure").value == 0) {
            this.fields.getField("Procedural Efficacy", "ASDDC Procedure Indications").hide = true;
            this.fields.getField("Procedural Efficacy", "ASD shunt Size").hide = true;
          }
          // cpem.EfficacyProcedureCode = "EFPRC03";
        }
        if (category == "Coarctation Procedure" || category == "CP Procedure Indications" || category.indexOf("Peak systolic gradient at coarctation") >= 0
          || category == "Any aneurysm post procedure" || category == "stent migration" || category == "Jailing of head/neck vessels") {
          if (this.fields.getField("Procedural Efficacy", "Coarctation Procedure").value == 1) {
            record = this.setEfficacyArray(category, "EFPRC04", updatedBy, caseId)
            if (record.EfficacyDataValue != null && record.EfficacyDataValue != undefined)
              result.push(record);
          }
          if (category == "Coarctation Procedure" && this.fields.getField("Procedural Efficacy", "Coarctation Procedure").value == 0) {
            record = this.setEfficacyArray(category, "EFPRC04", updatedBy, caseId)
            if (record.EfficacyDataValue != null && record.EfficacyDataValue != undefined)
              result.push(record);
          }
          if (category == "Coarctation Procedure" && this.fields.getField("Procedural Efficacy", "Coarctation Procedure").value == 1) {
            this.fields.getField("Procedural Efficacy", "CP Procedure Indications").hide = false;
            this.fields.getField("Procedural Efficacy", "Peak systolic gradient at coarctation Pre-Procedure").hide = false;
            this.fields.getField("Procedural Efficacy", "Peak systolic gradient at coarctation Post-Procedure").hide = false;
          }
          else if (this.fields.getField("Procedural Efficacy", "Coarctation Procedure").value == 0) {
            this.fields.getField("Procedural Efficacy", "CP Procedure Indications").hide = true;
            this.fields.getField("Procedural Efficacy", "Peak systolic gradient at coarctation Pre-Procedure").hide = true;
            this.fields.getField("Procedural Efficacy", "Peak systolic gradient at coarctation Post-Procedure").hide = true;
          }
          //  cpem.EfficacyProcedureCode = "EFPRC04";
        }
        if (category == "PDA Device Closure" || category == "PDADC Procedure Indications" || category == "PDA shunt Size" || category == "Residual Shunt"
          || category == "New left pulmonaryartery stenosis" || category == "New aortic arch obstruction" || category == "Hemolysis"
          || category == "Device removed from body" || category == "Was a second device placed?" || category == "PDA Reason for device removal"
          || category == "Was the second device removed?" || category == "PDA Reason for second device removal") {
          if (this.fields.getField("Procedural Efficacy", "PDA Device Closure").value == 1) {
            record = this.setEfficacyArray(category, "EFPRC05", updatedBy, caseId)
            if (record.EfficacyDataValue != null && record.EfficacyDataValue != undefined)
              result.push(record);
          }
          if (category == "PDA Device Closure" && this.fields.getField("Procedural Efficacy", "PDA Device Closure").value == 0) {
            record = this.setEfficacyArray(category, "EFPRC05", updatedBy, caseId)
            if (record.EfficacyDataValue != null && record.EfficacyDataValue != undefined)
              result.push(record);
          }
          if (category == "PDA Device Closure" && this.fields.getField("Procedural Efficacy", "PDA Device Closure").value == 1) {
            this.fields.getField("Procedural Efficacy", "PDADC Procedure Indications").hide = false;
            if (this.fields.getField("Procedural Efficacy", "Residual Shunt").value == 1) {
              this.fields.getField("Procedural Efficacy", "PDA shunt Size").hide = false;
            }
            else {
              this.fields.getField("Procedural Efficacy", "PDA shunt Size").hide = true;
            }
            if (this.fields.getField("Procedural Efficacy", "Device removed from body").value == 1) {
              this.fields.getField("Procedural Efficacy", "PDA Reason for device removal").hide = false;
            }
            else {
              this.fields.getField("Procedural Efficacy", "PDA Reason for device removal").hide = true;
            }
            if (this.fields.getField("Procedural Efficacy", "Was the second device removed?").value == 1) {
              this.fields.getField("Procedural Efficacy", "PDA Reason for second device removal").hide = false;
            }
            else {
              this.fields.getField("Procedural Efficacy", "PDA Reason for second device removal").hide = true;
            }
          }
          else if (this.fields.getField("Procedural Efficacy", "PDA Device Closure").value == 0) {
            this.fields.getField("Procedural Efficacy", "PDADC Procedure Indications").hide = true;
            this.fields.getField("Procedural Efficacy", "PDA shunt Size").hide = true;
            this.fields.getField("Procedural Efficacy", "PDA Reason for device removal").hide = true;
            this.fields.getField("Procedural Efficacy", "PDA Reason for second device removal").hide = true;
          }
          // cpem.EfficacyProcedureCode = "EFPRC05";
        }



      }
      return result;
    } catch (ex) {
      console.log(ex);
    }
  }
  setEfficacyArray(category: string, procCode: string, updatedBy: string, caseId: number) {
    try {
      let cpem = new CaseProcEfficacyModel;

      // let result = new Array<CaseProcEfficacyModel>();
      // let procs: Array<string> = ["Pre-Procedure", "Post-Procedure"];

      cpem.EfficacyProcedureCode = procCode;

      if (category.indexOf("Peak systolic AV gradient") >= 0 || category.indexOf("Aortic regurgitation") >= 0 || category.indexOf("Pulmonary regurgitation") >= 0
        || category.indexOf("Tricuspid valve regurgitation") >= 0 || category.indexOf("Peak systolic gradient at coarctation") >= 0) {
        //  for (let proc of procs) {
        try {
          // let cpem1 = new CaseProcEfficacyModel;
          cpem.EfficacyProcedureCode = cpem.EfficacyProcedureCode;
          let val = this.fields.getField("Procedural Efficacy", (category)).value;



          cpem.CaseProcEfficacyInfoid = this.fields.getField("Procedural Efficacy", (category)).id;
          cpem.CaseId = caseId;
          cpem.Updatedby = updatedBy;
          cpem.EfficacyDataName = category;
          cpem.EfficacyDataValue = val;

          if (category.indexOf("Pre-Procedure") >= 0) {
            cpem.IsDataPreProcTime = "1";

            cpem.IsDataPostProcTime = "0";
          }
          else if (category.indexOf("Post-Procedure") >= 0) {
            cpem.IsDataPreProcTime = "0";
            cpem.IsDataPostProcTime = "1";
          } else {
            cpem.IsDataPreProcTime = "0";
            cpem.IsDataPostProcTime = "0";

            // }

            // if ((val != null || val != undefined)) {
            //   result.push(cpem);
          }


        } catch (ex) {
          console.log(ex);
        }
        // }
      }
      else if (category == "Pre Pulmonary valve gradient" || category == "Post Pulmonary valve gradient" || category == "Pre Left Ventricle Dysfunction" || category == "Post Left Ventricle Dysfunction") {
        let val = this.fields.getField("Procedural Efficacy", (category)).value;

        cpem.CaseProcEfficacyInfoid = this.fields.getField("Procedural Efficacy", (category)).id;
        cpem.CaseId = caseId;
        cpem.Updatedby = updatedBy;
        cpem.EfficacyDataName = category;
        cpem.EfficacyDataValue = val;
        if (category == "Pre Pulmonary valve gradient") {
          cpem.IsDataPostProcTime = "0";
          cpem.IsDataPreProcTime = "1";
        }
        else {
          cpem.IsDataPostProcTime = "1";
          cpem.IsDataPreProcTime = "0";
        }

        //if ((val != null || val != undefined)) {
        // if ((cpem.IsDataPostProcTime == "0" && cpem.IsDataPreProcTime == "0" && cpem.EfficacyDataValue != "0")) {
        //  result.push(cpem);
        // }
        // }

      }
      else {

        let val = this.fields.getField("Procedural Efficacy", (category)).value;

        cpem.CaseProcEfficacyInfoid = this.fields.getField("Procedural Efficacy", (category)).id;
        cpem.CaseId = caseId;
        cpem.Updatedby = updatedBy;
        cpem.EfficacyDataName = category;
        cpem.EfficacyDataValue = val;
        cpem.IsDataPostProcTime = "0";
        cpem.IsDataPreProcTime = "0";
        // if ((val != null || val != undefined)) {
        // if ((cpem.IsDataPostProcTime == "0" && cpem.IsDataPreProcTime == "0" && cpem.EfficacyDataValue != "0"))
        //  {
        //  result.push(cpem);
        //  }          
        //  }

      }

      return cpem;
    } catch (ex) {
      console.log(ex);
    }
  }
}
